const Table = ({ columns, rows }) => (
  <table striped bordered hover>
    <thead>
      <tr>
        {columns?.map(row => (
          <th key={row.name}>{row.name}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows?.map(row => (
        <tr>
          {row.items?.map(item => (
            <td>{item.name}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

Table.defaultProps = {
  columns: [{ name: 'first' }, { name: 'second' }],
  rows: [
    {
      items: [{ name: 'first' }, { name: 'second' }]
    },
    {
      items: [{ name: 'first' }, { name: 'second' }]
    }
  ]
};

export default Table;
